import React, { Component } from 'react'
import { connect } from 'react-redux'
import Chart from "react-apexcharts";
import { checkInternet } from './../utils/checkInternet'
import {  pageTitle , hasInternet , isHome} from './../actions'
import { Calendar } from 'react-datepicker2';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import loading from './../assets/images/loading.gif'
import $ from "jquery";

class ItemDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.params ? props.params.id : undefined,
            to_date:"",
            from_date:"",
            show_loading:true

        }
    }
    componentDidMount() {
        $(document).mouseup(e => {
            var container = $(".clickable-area");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                this.setState({show_fromDate: false,show_toDate: false })
                
            }
        });
        this.props.dispatch(isHome(false))
        this.props.dispatch(pageTitle("جزییات"));
        this.props.dispatch(hasInternet(checkInternet()))
        this.props.socket !== null ? this.getData(this.props.socket) : console.log("not yet");
    }
    componentWillReceiveProps(nextProps) {
        this.props.dispatch(hasInternet(checkInternet()))
        
        nextProps.socket !== null ? this.getData(nextProps.socket) : console.log("not yet");
    }
    getData = socket => {
        this.setState({show_loading:true})
        const { id , from_date, to_date} = this.state;
        socket.on('items_detail', data => {
            this.setState({ show_loading:false,prices_labels: data.prices_labels, prices_values: data.prices_values, information: data.item });

        })
        console.log(from_date,to_date);
        socket.emit("items_detail", {id,from:from_date,to:to_date});
    }
    handleFromData = () => {
        this.setState({ show_fromDate: true ,show_toDate:false})
    }
    handleToData = () => {
        
        this.setState({ show_toDate: true,show_fromDate:false })
    }
    
    resetFilter =async ()=>{
        this.setState({from_date:"", to_date:""},()=>{
            this.getData(this.props.socket);
        });
        
    }
    render() {
        const { show_loading,show_toDate, prices_labels, prices_values, information, from_date, to_date, show_fromDate } = this.state;
        const options = {
            chart: {
                id: "basic-bar"
            },
            xaxis: {
                categories: prices_labels
            }
        },

            series = [
                {
                    name: information ? `فروش(${information.unit})` : "",
                    data: prices_values
                }
            ]
        return (
            prices_labels ?
                <div className="item-detail">
                    <h1>{information.name}</h1>
                    <div className='information-box'>
                        <span>آخرین قیمت : {information.price}  {information.unit}</span>
                        <span>آخرین بروز رسانی در
                            <span> {information.date}</span>
                            <span> {information.time}</span>
                        </span>
                    </div>
                    <div className='information-box'>
                        <img src={loading} className={`filter-loading ${show_loading?"show":""}`} alt='loading' />
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <span className="input-area clickable-area" onClick={this.handleFromData}>
                                    {from_date.trim() === "" ? "از تاریخ" : from_date}
                                </span>

                                <div className={`custom-date  clickable-area ${show_fromDate ? "show" : ""}` }>

                                    <Calendar
                                        isGregorian={false}
                                        onChange={value => this.setState({ show_fromDate: false, from_date: value.locale('fa').format('jYYYY/jM/jD') })}
                                        value={this.state.from_date}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                            <span className="input-area clickable-area" onClick={this.handleToData}>
                                    {to_date.trim() === "" ? "تا تاریخ" : to_date}
                                </span>
                                <div className={`custom-date clickable-area ${show_toDate ? "toShow" : ""}`}>

                                    <Calendar
                                        isGregorian={false}
                                        onChange={value => this.setState({ show_toDate: false, to_date: value.locale('fa').format('jYYYY/jM/jD') })}
                                        value={this.state.to_date}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6} style={{ display: "flex", alignItem: "center", justfyContent: "center" }}>
                                <Button onClick={this.resetFilter} className="remove-btn" color="primary" style={{ width: "100%", height: "40px", margin: "auto 0", marginBottom: "5px" }}>
                                    پاک کردن فیلتر
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6} style={{ display: "flex", alignItem: "center", justfyContent: "center" }}>
                                <Button onClick={()=>this.getData(this.props.socket)} className="save-btn" color="primary" style={{ width: "100%", height: "40px", margin: "auto 0", marginBottom: "5px" }}>
                                    اعمال
                                </Button>
                            </Grid>
                        </Grid>
                    </div>

                    <Chart
                        options={options}
                        series={series}
                        type="area"
                        width="100%"
                        height="400"
                    />
                </div>
                : null
        );
    }
}

const mapStateToProps = state => {
    return {
        socket: state.setSocket,
    }
}
export default connect(mapStateToProps)(ItemDetail);
